// 设备 store — 当前房间内的 peers 列表

import { create } from 'zustand';
import type { ClientInfo } from '@kuaichuan/shared';

interface DeviceState {
  self: ClientInfo | null;
  peers: ClientInfo[];
  setSelf: (self: ClientInfo | null) => void;
  setPeers: (peers: ClientInfo[]) => void;
  addPeer: (peer: ClientInfo) => void;
  removePeer: (peerId: string) => void;
  updatePeer: (peer: ClientInfo) => void;
  clear: () => void;
}

export const useDeviceStore = create<DeviceState>((set) => ({
  self: null,
  peers: [],
  setSelf: (self) => set({ self }),
  setPeers: (peers) => set({ peers }),
  addPeer: (peer) =>
    set((s) =>
      s.peers.some((p) => p.id === peer.id) ? s : { peers: [...s.peers, peer] },
    ),
  removePeer: (peerId) => set((s) => ({ peers: s.peers.filter((p) => p.id !== peerId) })),
  updatePeer: (peer) =>
    set((s) => ({
      peers: s.peers.map((p) => (p.id === peer.id ? peer : p)),
    })),
  clear: () => set({ self: null, peers: [] }),
}));
